'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M16 256c0 32.6 18.3 60.9 45.2 75.2l5.8 3.1-1.9 6.3c-8.9 29.1-1.9 62.1 21.1 85.1s56 30.1 85.1 21.1l6.3-1.9 3.1 5.8C195.1 477.7 223.4 496 256 496s60.9-18.3 75.2-45.2l3.1-5.8 6.3 1.9c29.1 8.9 62.1 1.9 85.1-21.1s30.1-56 21.1-85.1l-1.9-6.3 5.8-3.1C477.7 316.9 496 288.6 496 256s-18.3-60.9-45.2-75.2l-5.8-3.1 1.9-6.3c9-29.1 1.9-62.1-21.1-85.1s-56-30.1-85.1-21.1l-6.3 1.9-3.1-5.8C316.9 34.3 288.6 16 256 16s-60.9 18.3-75.2 45.2l-3.1 5.8-6.3-1.9c-29.1-8.9-62.1-1.9-85.1 21.1s-30.1 56-21.1 85.1l1.9 6.3-5.8 3.1C34.3 195.1 16 223.4 16 256zm130.3-2.3l11.3-11.3L224 308.7 354.3 178.3l11.3 11.3-136 136-5.7 5.7-5.7-5.7-72-72z', 'M180.8 61.2C195.1 34.3 223.4 16 256 16s60.9 18.3 75.2 45.2l3.1 5.8 6.3-1.9c29.1-8.9 62.1-1.9 85.1 21.1s30.1 56 21.1 85.1l-1.9 6.3 5.8 3.1C477.7 195.1 496 223.4 496 256s-18.3 60.9-45.2 75.2l-5.8 3.1 1.9 6.3c8.9 29.1 1.9 62.1-21.1 85.1s-56 30.1-85.1 21.1l-6.3-1.9-3.1 5.8C316.9 477.7 288.6 496 256 496s-60.9-18.3-75.2-45.2l-3.1-5.8-6.3 1.9c-29.1 8.9-62.1 1.9-85.1-21.1s-30.1-56-21.1-85.1l1.9-6.3-5.8-3.1C34.3 316.9 16 288.6 16 256s18.3-60.9 45.2-75.2l5.8-3.1-1.9-6.3c-8.9-29.1-1.9-62.1 21.1-85.1s56-30.1 85.1-21.1l6.3 1.9 3.1-5.8zM256 0c-36.4 0-68.3 19.3-86.1 48.2c-33-7.9-69.2 1.1-94.9 26.8s-34.7 61.9-26.8 94.9C19.3 187.7 0 219.6 0 256s19.3 68.3 48.2 86.1c-7.9 33 1.1 69.2 26.8 94.9s61.9 34.7 94.9 26.8C187.7 492.7 219.6 512 256 512s68.3-19.3 86.1-48.2c33 7.9 69.2-1.1 94.9-26.8s34.7-61.9 26.8-94.9C492.7 324.3 512 292.4 512 256s-19.3-68.3-48.2-86.1c7.9-33-1.1-69.2-26.8-94.9s-61.9-34.7-94.9-26.8C324.3 19.3 292.4 0 256 0zM229.7 325.7l136-136-11.3-11.3L224 308.7l-66.3-66.3-11.3 11.3 72 72 5.7 5.7 5.7-5.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;